/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBuyerAccount} from '../api'

 export const useQueryGetBuyerAccount = createReactQueryHook('getBuyerAccount', getBuyerAccount)
